import Vue from 'vue'

import { app } from '@/main'

class MessageService {
  static error (title: string, message: string, hideDelay?: number) {
    app.$bvToast.toast(message, {
      title: title || 'Error',
      variant: 'danger',
      toaster: 'b-toaster-top-center',
      autoHideDelay: hideDelay || 7000
    })
  }

  static success (title: string, message: string, hideDelay?: number) {
    app.$bvToast.toast(message, {
      title: title || 'Éxito',
      variant: 'success',
      toaster: 'b-toaster-top-center',
      autoHideDelay: hideDelay || 7000
    })
  }
}

export default MessageService
